<template>
    <div class="gibs-newsletter-form-container">
        <div class="newsletter-form-wrapper">
            <form>
                <div class="gibs-signup-wrapper">
                    <div class="gibs-signup-containers">
                        <div class="gibs-newsletter-form-elements-container">
                            <p class="gibs-share-prod-form-title">Request Quote/Proforma Invoice</p>
                            <form @submit.prevent="submitForm" class="form-container" id="proforma-request-form-id">
                                <hr class="gibs-divider mb-[17px]" />
                                <div class="gibs-share-prod-form-subtitle">{{ proformaRequestStore.getSubProgrammeName }}
                                </div>
                                <template v-if="isSubmitted">
                                    <div class="mt-4 mb-4">
                                        <p class="font-bold mb-2">{{ proformaRequestStore.getSubProgrammeName }} PROFORMA INVOICE/QUOTATION REQUEST:</p>
                                        <p>Thank you for your enquiry and your interest in our Academic Programmes. We will revert back to you shortly with your request. Should there be any queries in this regard, please kindly contact the Admissions Office on <a href="mailto:admissions@gibs.co.za">admissions@gibs.co.za</a> or 011 771 4135.</p>
                                    </div>
                                    <div class="mt-4.5 max-w-full xs:w-full xs:max-w-full">
                                        <GibsControlPrimaryButton :primaryButtonSpec="closeBtn" type="button"
                                            @click="closeForm" />
                                    </div>
                                </template>
                                <template v-else>
                                    <p class="mb-[17px]"></p>
                                    <hr class="gibs-divider mb-[17px]" />
                                    <GibsControlFormInput type="email" inputId="proforma-request-email" labelText="Email"
                                        class="mb-4" placeholderText="Email address" v-model="form.Email" :is-required="true"
                                        :validator="validation"
                                        :validator-rule-id="useNuxtApp().$EnumProformaRequestFormValidatorId.Email"
                                        @input="emailInput">
                                    </GibsControlFormInput>
                                    <GibsControlFormInput type="text" inputId="proforma-request-first-name"
                                        labelText="First Name" placeholderText="First name" v-model="form.Name"
                                        @input="nameInput" :validator="validation" :isRequired="true"
                                        :validator-rule-id="useNuxtApp().$EnumProformaRequestFormValidatorId.Name">
                                    </GibsControlFormInput>
                                    <GibsControlFormInput type="text" inputId="proforma-request-surname"
                                        labelText="Surname" placeholderText="Surname" v-model="form.LastName"
                                        @input="surnameInput" :isRequired="true" :validator="validation"
                                        :validator-rule-id="useNuxtApp().$EnumProformaRequestFormValidatorId.Surname">
                                    </GibsControlFormInput>
                                    <GibsControlFormDropdown inputId="proforma-request-financial-method"
                                        labelText="Financial Method" :isRequired="true"
                                        :options="financialMethodOptions" :validator="validation"
                                        :validator-rule-id="useNuxtApp().$EnumProformaRequestFormValidatorId.FinancialMethod"
                                        @dropdownSelection="financialMethodInput">
                                    </GibsControlFormDropdown>
                                    <GibsControlFormInput type="text" inputId="proforma-request-company-name"
                                        labelText="Company Name" placeholderText="Company name" v-model="form.CompanyName"
                                        @input="companyNameInput" :isRequired="false" :validator="validation"
                                        :validator-rule-id="useNuxtApp().$EnumProformaRequestFormValidatorId.CompanyName">
                                    </GibsControlFormInput>
                                    <GibsControlFormInput type="text" inputId="proforma-request-company-address"
                                        labelText="Company Address Details" placeholderText="Company address"
                                        v-model="form.CompanyAddress" @input="companyAddressInput" :isRequired="false"
                                        :validator="validation"
                                        :validator-rule-id="useNuxtApp().$EnumProformaRequestFormValidatorId.CompanyAddress">
                                    </GibsControlFormInput>
                                    <GibsControlFormInput type="text" inputId="proforma-request-postal-code"
                                        labelText="Postal Code" placeholderText="Postal code" v-model="form.PostalCode"
                                        @input="postalCodeInput" :isRequired="false" :validator="validation"
                                        :validator-rule-id="useNuxtApp().$EnumProformaRequestFormValidatorId.PostalCode">
                                    </GibsControlFormInput>
                                    <GibsControlFormInput type="text" inputId="proforma-request-vat-number"
                                        labelText="Company VAT Number" placeholderText="Company VAT number"
                                        v-model="form.CompanyVATNumber" @input="vatNumberInput" :isRequired="false"
                                        :validator="validation"
                                        :validator-rule-id="useNuxtApp().$EnumProformaRequestFormValidatorId.CompanyVATNumber">
                                    </GibsControlFormInput>
                                    <div class="mt-4.5 max-w-full xs:w-full xs:max-w-full">
                                        <GibsControlPrimaryButton :primaryButtonSpec="submitBtn" type="submit"
                                            @click="submitForm" />
                                    </div>
                                </template>
                            </form>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useNotificationStore } from "~/stores/notification";
import { ServerValidationError } from "~/classes/validation-errors";
import { useProformaRequestStore } from '~/stores/proforma-request';
import type { IProformaRequestForm } from '~/interfaces/proforma-request-form';

const emit = defineEmits(["closeModal"]);

const store = useNotificationStore();
const app = useNuxtApp();
const proformaRequestStore = useProformaRequestStore();

const isSubmitted = ref(false);

const financialMethodOptions = ref<Array<IDropdownItem>>([
    { id: 'Self', itemText: 'Self' },
    { id: 'Company', itemText: 'Company' },
    { id: 'Joint', itemText: 'Joint (Self and Company)' }
]);

const form = ref<IProformaRequestForm>({
    Email: "",
    Name: "",
    LastName: "",
    FinancialMethod: "",
    CompanyName: "",
    CompanyAddress: "",
    PostalCode: "",
    CompanyVATNumber: "",
    ProgrammeID: "",
    AlertMe: false,
    Message: "",
    IsProformaInvoiceLead: false
});

const { proformaRequestFormValidation } = useValidations();
const validation = proformaRequestFormValidation(form.value);

const submitBtn = ref<IControlButton>({
    buttonElName: "gibs-primary-button",
    buttonText: "Submit",
    class: "btn-create-profile gibs-btn-share-closed-application",
    sourceUrl: "",
    load: false
});
submitBtn.value.disabled = !validation.isValid();

const closeBtn = ref<IControlButton>({
    buttonElName: "gibs-primary-button",
    buttonText: "Close",
    class: "btn-create-profile gibs-btn-share-closed-application",
    sourceUrl: "",
    load: false,
    disabled: false
});

function emailInput(input: string) {
    form.value.Email = input;
    validation.setValidationRuleSourceValue(app.$EnumProformaRequestFormValidatorId.Email, input);
    submitBtn.value.disabled = !validation.isValid();
}

function nameInput(input: string) {
    form.value.Name = input;
    validation.setValidationRuleSourceValue(app.$EnumProformaRequestFormValidatorId.Name, input);
    submitBtn.value.disabled = !validation.isValid();
}

function surnameInput(input: string) {
    form.value.LastName = input;
    validation.setValidationRuleSourceValue(app.$EnumProformaRequestFormValidatorId.Surname, input);
    submitBtn.value.disabled = !validation.isValid();
}

function financialMethodInput(selected: IDropdownItem) {
    form.value.FinancialMethod = selected.id;
    validation.setValidationRuleSourceValue(app.$EnumProformaRequestFormValidatorId.FinancialMethod, selected.id);
    submitBtn.value.disabled = !validation.isValid();
}

function companyNameInput(input: string) {
    form.value.CompanyName = input;
    validation.setValidationRuleSourceValue(app.$EnumProformaRequestFormValidatorId.CompanyName, input);
    submitBtn.value.disabled = !validation.isValid();
}

function companyAddressInput(input: string) {
    form.value.CompanyAddress = input;
    validation.setValidationRuleSourceValue(app.$EnumProformaRequestFormValidatorId.CompanyAddress, input);
    submitBtn.value.disabled = !validation.isValid();
}

function postalCodeInput(input: string) {
    form.value.PostalCode = input;
    validation.setValidationRuleSourceValue(app.$EnumProformaRequestFormValidatorId.PostalCode, input);
    submitBtn.value.disabled = !validation.isValid();
}

function vatNumberInput(input: string) {
    form.value.CompanyVATNumber = input;
    validation.setValidationRuleSourceValue(app.$EnumProformaRequestFormValidatorId.CompanyVATNumber, input);
    submitBtn.value.disabled = !validation.isValid();
}

function submitForm() {
    try {
        debugger;
        const formData: IProformaRequestForm = {
            ProgrammeID: proformaRequestStore.getSubProgrammeId,
            Email: form.value.Email,
            Name: form.value.Name,
            LastName: form.value.LastName,
            FinancialMethod: form.value.FinancialMethod,
            CompanyName: form.value.CompanyName,
            CompanyAddress: form.value.CompanyAddress,
            PostalCode: form.value.PostalCode,
            CompanyVATNumber: form.value.CompanyVATNumber,
            AlertMe: true,
            Message: "Request for Quote/Proforma Invoice",
            IsProformaInvoiceLead: true
        };
        
        sendDataToServer(formData);
    } catch (error) {
        let bodyText;
        if (error instanceof Error) {
            bodyText = error.message;
        } else {
            bodyText = '';
        }

        store.addNotification({
            type: "error",
            title: `There was an error while submitting the proforma request. Please try again.`,
            body: bodyText,
            date: new Date(),
            timeout: true,
            timer: 10000
        });
    }
}

const sendDataToServer = async (formData: IProformaRequestForm) => {
    let notification: INotification;

    try {
        submitBtn.value.disabled = true;
        submitBtn.value.load = true;

        const { data: response, error, status } = await useLoaderFetch("/api/proformarequest/postFormData", {
            method: "POST",
            body: formData
        });

        submitBtn.value.disabled = false;
        submitBtn.value.load = false;

        if (response != null) {
            const isSuccess: string = "success";
            const isError: string = "error";

            if (status.value === isSuccess) {
                isSubmitted.value = true;
            } else if (status.value === isError) {
                notification = {
                    type: "error",
                    title: "",
                    body: `There was an error while submitting the proforma request. Please try again.`,
                    date: new Date(),
                    timeout: true,
                    timer: 10000
                };
                store.addNotification(notification);
            }
        }
    } catch (error) {
        let bodyText;
        if (error instanceof ServerValidationError) {
            bodyText = error.message;
        } else {
            bodyText = (error as Error).message;
        }

        notification = {
            type: "error",
            title: "An error occurred.",
            body: bodyText,
            date: new Date(),
            timeout: true,
            timer: 10000
        };
        store.addNotification(notification);
    }
};

function closeForm() {
    isSubmitted.value = false;
    form.value.Email = "";
    form.value.Name = "";
    form.value.LastName = "";
    form.value.FinancialMethod = "";
    form.value.CompanyName = "";
    form.value.CompanyAddress = "";
    form.value.PostalCode = "";
    form.value.CompanyVATNumber = "";
    form.value.ProgrammeID = "";
    submitBtn.value.disabled = !validation.isValid();
    emit("closeModal");
}
</script>
